import { FormInput } from "@circle-react-uikit/Form/FormInput";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useState } from "react";
import { ColorService } from "react-color-palette";
import { useFormContext } from "react-hook-form";

import { t } from "@/i18n-js/instance";
import { anchorClassNames } from "@/react/helpers/cssAnchorHelpers";

import { ColorPickerPrefix } from "./ColorPickerPrefix";

const isHexColor = (color = "") =>
  /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(color);

export const FormColorPickerV1 = ({
  name,
  disabled = false,
  id,
  ...rest
}: {
  disabled?: boolean;
  id?: string;
  name: string;
}) => {
  const { watch, setValue } = useFormContext();
  const [shouldShow, setShouldShow] = useState(false);
  const colorValue: string = watch(name);

  return (
    <FormInput
      {...rest}
      disabled={disabled}
      id={id}
      variant="text"
      name={name}
      maxLength={7}
      rules={{
        validate: (value: string) => {
          if (!isHexColor(value)) {
            return t("invalid_color");
          }
          return true;
        },
      }}
      onBlur={() => {
        const color = ColorService.convert("hex", colorValue);
        setValue(name, color.hex, { shouldDirty: true, shouldValidate: true });
      }}
      prefix={
        <ColorPickerPrefix
          value={colorValue}
          disabled={disabled}
          shouldShow={shouldShow}
          onChange={value =>
            !disabled &&
            setValue(name, value, { shouldDirty: true, shouldValidate: true })
          }
          onOpenPicker={() => !disabled && setShouldShow(true)}
          onClosePicker={() => !disabled && setShouldShow(false)}
        />
      }
      className={classNames(
        anchorClassNames("form-control"),
        "!border-l-0 uppercase",
      )}
    />
  );
};
